export default __webpack_public_path__ + "static/media/cd.2e86ed1a.jpg";